import { NOTIFICATIONS_BASE_PATH, type NotificationView } from "./notificationViews";

/**
 * Maps a legacy `/admin/notifications?tab=...` search string onto the
 * per-view route (PWA-2748 Section 3.2). `tab` is consumed; `message=new`
 * under the drafts tab becomes the New notification page; every other
 * search param is preserved.
 */
export function legacyNotificationsRedirectPath(search: string): string {
  const params = new URLSearchParams(search);
  const tab = params.get("tab");
  params.delete("tab");
  let view: NotificationView = "reports";
  if (tab === "users") view = "users";
  else if (tab === "completed") view = "completed";
  else if (tab === "drafts") {
    if (params.get("message") === "new") {
      params.delete("message");
      view = "new";
    } else {
      view = "drafts";
    }
  }
  const query = params.toString();
  return `${NOTIFICATIONS_BASE_PATH}/${view}${query ? `?${query}` : ""}`;
}
